export const AMAP_KEY = '259d3a9fde5403c4b5467d6d464472e5';
export const AMAP_SECURITY_JS_CODE = '55d4be1aab3a56d47206d45cb516e5c9';
export const FULLSCREEN_AMAP_STYLE = 'amap://styles/darkblue';

let amapLoaderPromise = null;

function ensureAmapLoader() {
    if (window.AMapLoader) {
        return Promise.resolve(window.AMapLoader);
    }

    if (amapLoaderPromise) {
        return amapLoaderPromise;
    }

    amapLoaderPromise = new Promise((resolve, reject) => {
        const existScript = document.getElementById('amap-jsapi-loader');
        if (existScript) {
            existScript.addEventListener('load', () => {
                if (window.AMapLoader) {
                    resolve(window.AMapLoader);
                    return;
                }
                reject(new Error('AMapLoader 未挂载到 window'));
            }, { once: true });
            existScript.addEventListener('error', () => {
                reject(new Error('高德地图 loader.js 加载失败'));
            }, { once: true });
            return;
        }

        const script = document.createElement('script');
        script.id = 'amap-jsapi-loader';
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://webapi.amap.com/loader.js';
        script.onload = () => {
            if (window.AMapLoader) {
                resolve(window.AMapLoader);
                return;
            }
            reject(new Error('AMapLoader 未挂载到 window'));
        };
        script.onerror = () => {
            reject(new Error('高德地图 loader.js 加载失败'));
        };
        document.head.appendChild(script);
    });

    return amapLoaderPromise;
}

function ensurePlugins(AMap, plugins = []) {
    if (!plugins.length || !AMap || typeof AMap.plugin !== 'function') {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        try {
            AMap.plugin(plugins, () => {
                resolve();
            });
        } catch (error) {
            reject(error);
        }
    });
}

export async function loadAmap(options = {}) {
    const {
        plugins = [],
        securityJsCode = AMAP_SECURITY_JS_CODE,
        key = AMAP_KEY,
        version = '2.0',
    } = options;

    window._AMapSecurityConfig = Object.assign({}, window._AMapSecurityConfig, {
        securityJsCode,
    });

    const AMapLoader = await ensureAmapLoader();
    const AMap = await AMapLoader.load({
        key,
        version,
    });

    await ensurePlugins(AMap, plugins);
    return AMap;
}

export function createFullscreenAmap(AMap, el, options = {}) {
    const {
        center,
        zoom,
        zooms = [3, 18],
        mapStyle = FULLSCREEN_AMAP_STYLE,
        showLabel = true,
        terrain = false,
        withScale = true,
    } = options;

    const map = new AMap.Map(el, {
        viewMode: '3D',
        center,
        zoom,
        zooms,
        mapStyle,
        showLabel,
        terrain,
    });

    if (withScale && AMap.Scale) {
        map.addControl(new AMap.Scale());
    }

    return map;
}

export function createCountryDistrictLayer(AMap, map, styles = {}) {
    if (!AMap || !map || !AMap.DistrictLayer || !AMap.DistrictLayer.Country) {
        return null;
    }

    const layer = new AMap.DistrictLayer.Country({
        SOC: 'CHN',
        depth: 1,
        zIndex: 10,
        styles,
    });
    layer.setMap(map);
    return layer;
}

export function bd09ToGcj02(lng, lat) {
    const xPi = Math.PI * 3000.0 / 180.0;
    const x = lng - 0.0065;
    const y = lat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPi);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPi);
    return [
        z * Math.cos(theta),
        z * Math.sin(theta),
    ];
}
